const cn = {
  // 公共
  common: {
    copyright: 'Solestage版权所有',
    create: '新建',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    export: '导出',
    warning: '警告',
    save: '保存',
    error: '操作失败',
    success: '操作成功',
    emptyMsg: '不可为空！',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    finishTime: '完成时间',
    confirm: '确定',
    cancel: '取消',
    back: '返回',
    email: '邮箱',
    notEmpty: '不可为空',
    notAppear: '如果它没有出现在您的主邮箱中，请检查您的垃圾邮件和促销文件夹',
    notReceived: '没有收到邮件?',
    send: '发送',
    wait: '请在请求另一个链接之前等待30秒让电子邮件到达',
    resend: '重新发送链接',
    accountSettings: '账户设置',
    logOut: '退出登录',
    logOutMsg: '确定要退出登录吗？',
    updateUserSuccess: '用户信息已更新！',
    saveUserFail: '保存失败，请稍后重试！',
    saveUserValidate: '请检查输入内容！',
    nickName: '用户名',
    username: '账号',
    usernameCheck: '账号格式不正确',
    password: '原密码',
    passwordToolTips: '请您输入原密码',
    newPassword: '新密码',
    newPasswordTooltip: '请您输入新密码',
    againPassword: '确认密码',
    againPasswordTooltip: '请您再次输入新密码',
    checkFomart: '格式不正确',
    noPassword: '您的密码不正确',
    failChangePassword: '修改密码失败!',
    inconformity: '两次秘密输入不一致！',
    identical: '新密码与原密码一致！',
    againLogin: '请您重新登录',
    defaultSet: '基本设置',
    passwordSet: '密码设置',
    passwordRule: '密码至少需要6位，包含数字、字母2种组合',
    networkError: '网络错误',
    tryagain: '请重试',
    zero: '',
    deleteSuccess: '删除成功！',
    correctNum: '请输入正确的数字',
    getZero: '请输入大于0的数字',
    abnormalOperation: '操作异常',
    waitData: '数据加载中，请稍等',
    createSuccess: '创建成功！',
    noNewsYet: '暂无消息通知~'
  },
  // 菜单管理menu
  menu: {
    home: '首页',
    storeManagement: '仓库管理',
    shelvesManagement: '货架管理',
    store: '仓库管理',
    shelves: '货架管理',
    cargoSpace: '货位管理',
    userManagement: '用户管理',
    accountManagement: '账号管理',
    supplierManagement: '供应商管理',
    supplier: '供应商管理',
    supplierAudit: '供应商注册审核',
    appUser: 'APP用户',
    userRole: '角色管理',
    settings: '基础设置',
    commodityLibrary: '商品库管理',
    category: '品类管理',
    brand: '品牌管理',
    series: '系列管理',
    commodity: '商品管理',
    orderManagement: '订单管理',
    identificationOrder: '鉴定订单',
    aiIdentification: 'AI鉴别',
    onlineIdentification: '在线鉴别',
    marketing: '内容营销管理',
    feedback: '意见反馈'
  },
  // 用户管理模块
  accountManagement: { // 账号管理
    pageTitle: '账号管理',
    tableTitle: '账号列表',
    create: '新建',
    nickName: '用户名称',
    userRole: '角色',
    name: '员工',
    email: '电子邮箱',
    accountStatus: '账号状态',
    disabled: '禁用',
    category: '鉴定品类',
    enabled: '启用',
    reset: '重置密码',
    password: '密码',
    passwordAgain: '确认密码',
    passwordDiff: '两次输入密码不一致！',
    enableMsg: '是否要启用该用户账号？',
    disableMsg: '是否要禁用该用户账号？',
    disSuccessMsg: '已成功禁用该用户账号！',
    enSuccessMsg: '已成功启用该用户账号！',
    createTitle: '新增账户',
    editTitle: '编辑账户',
    createAccountSuccess: '账户创建成功！',
    createAccountFail: '账户创建失败，请稍后重试！',
    eidtAccountSuccess: '账户修改成功！',
    eidtAccountFail: '账户修改失败，请稍后重试！',
    resetSuccess: '密码重置成功！',
    resetFail: '密码重置失败，请稍后重试！',
    alreadyExist: '此邮箱账号已存在！'
  },
  supManagement: { // 供应商管理
    pageTitle: '供应商管理',
    tableTitle: '供应商列表',
    nickName: '用户名称',
    email: '电子邮箱',
    phone: '联系电话',
    account: '账户',
    address: '地址',
    accountStatus: '账号状态',
    disabled: '禁用',
    enabled: '启用',
    enableMsg: '是否要启用该供应商账号？',
    disableMsg: '是否要禁用该供应商账号？',
    disSuccessMsg: '已成功禁用该供应商账号！',
    enSuccessMsg: '已成功启用该供应商账号！'
  },
  supplierAudit: { // 供应商注册审核
    pageTitle: '供应商注册审核',
    tableTitle: '申请列表',
    email: '电子邮箱',
    shoeCount: '鞋子数量',
    monthlyNo: '月销量',
    monthlySales: '月销售额',
    mainSalesPlateforms: '主要销售平台',
    replenish: '补充说明',
    status: '审核状态',
    pass: '通过',
    unpass: '拒绝',
    passMsg: '是否要通过此供应商账号申请吗？',
    successMsg: '审核成功！',
    unpassTitle: '用户注册审核',
    cause: '拒绝原因',
    placeholder: '请输入拒绝原因',
    existed: '账户已存在'
  },
  appUser: { // app用户
    pageTitle: 'APP用户',
    tableTitle: '用户列表',
    avatar: '头像',
    nickName: '用户名',
    email: '电子邮箱',
    sex: '性别',
    signature: '个性签名',
    balance: '余额',
    detailHeader: '用户详情',
    userInfo: '基本信息',
    nickNameDetail: '用户名：',
    emailDetail: '邮箱：',
    sexDetail: '性别：',
    signatureDetail: '个性签名：',
    walletDetail: '钱包：',
    walletRecord: '钱包收支'
  },
  walletDetails: { // 钱包明细
    pageTitle: '钱包明细',
    tableTitle: '收支记录',
    type: '收支类型',
    identify: '鉴别类型',
    account: '金额',
    balance: '余额'
  },
  login: { // 登录
    name: 'SOLESTAGE管理后台',
    welcome: 'Hi,欢迎使用本系统',
    invalid: '很抱歉,当前帐号不存在',
    title: '帐号登录',
    password: '密码',
    forget: '忘记密码?',
    login: '登录',
    emailSendError: '邮件发送异常',
    emailCD: '请等一分钟后再次发送',
    signup: '注册供应商帐号',
    fill: '请填写帐号密码',
    fail: '无法登录',
    errorPassword: '帐号或密码错误',
    disable: '此账号已被管理员禁用！'
  },
  forget: { // 忘记密码
    title: '忘记密码',
    tooltip: '输入您注册时使用的电子邮件以恢复您的密码',
    sent: '我们已向您发送一封电子邮件,其中包含重置密码的链接',
    resendAsk: '您需要我们重新发送链接吗？',
    invalidEmail: '此邮箱未注册',
    disabledEmail: '此邮箱已停用',
    disable: '此账号已被管理员禁用！',
    toSignup: '请前往注册界面进行注册',
    subject: 'solestage 重置密码',
    emailInfo: {
      title: '重置密码',

      msg: '我们收到了重置密码的请求。点击下面的按钮，您就可以重置了。',
      btn: '重置密码',
      msg2: '如果您错误地收到此邮件，请忽略此电子邮件。如果您认为其他人在未经您同意的情况下使用您的账户，请与我们联系'
    }
  },
  signup: { // 供应商注册
    title: '注册供应商帐号',
    accountExisted: '已有帐号?',
    login: '立即登录',
    signup: '注册',
    invalid: '邮箱格式异常',
    haveSent: '我们已向您发送一封电子邮件,请继续完成注册操作',
    ask: '您需要我们重新发送链接吗？',
    existEmail: '邮箱已存在',
    toLogin: '请前往登录',
    subject: 'solestage 供应商注册',
    disabledEmail: '此邮箱已停用',
    disable: '此账号已被管理员禁用！',
    emailInfo: {
      title: '注册供应商帐号',
      msg: '我们收到了注册帐号的请求。点击下面的按钮，您就可以注册了。',
      btn: '注册帐号',
      msg2: '如果您错误地收到此邮件，请忽略此电子邮件。如果您认为其他人在未经您同意的情况下使用您的账户，请与我们联系'
    }
  },
  userRole: { // 用户角色
    pageTitle: '角色管理',
    tableTitle: '角色列表',
    roleName: '角色',
    authorization: '授权',
    createTitle: '新建角色',
    editTitle: '编辑角色',
    createSuccess: '创建成功！',
    createFail: '创建失败，请稍后重试！',
    editSuccess: '修改成功！',
    editFail: '修改失败！',
    deleteConfirm: '确定要删除此角色吗？',
    deleteSuccess: '删除成功！',
    hasUser: '此角色下包含用户，不可删除！'
  },
  permission: { // 权限
    pageTitle: '授权',
    title: '功能权限',
    introduce: '设置角色对应的功能操作、应用管理、后台管理权限',
    checkall: '全选',
    save: '保存',
    saveMsg: '确定要修改当前角色权限吗？',
    saveSuccess: '修改成功！',
    saveFail: '修改失败，请稍后重试！'
  },
  store: { // 仓库管理
    pageTitle: '仓库管理',
    tableTitle: '仓库列表',
    name: '仓库名称',
    user: '联系人',
    contact: '联系方式',
    location: '仓库地址',
    createdAt: '创建时间',
    createTitle: '创建仓库',
    createStoreSuccess: '仓库创建成功！',
    createStoreFail: '仓库创建失败！',
    storeNameExisted: '仓库名已存在',
    reviseStoreName: '请修改仓库名称',
    editTitle: '编辑仓库',
    editSuccess: '仓库信息已修改',
    deleteTitle: '删除仓库',
    deleteStore: '确认删除此仓库？',
    deleteFailed: '删除失败',
    existShelf: '仓库下有货架',
    deleteSuccess: '仓库已删除'
  },
  shelves: { // 货架管理
    pageTitle: '货架管理',
    tableTitle: '货架列表',
    createTitle: '创建货架',
    editShelves: '编辑货架',
    storehouse: '仓库',
    numbering: '货架编号',
    cargoRows: '货排数',
    singleRow: '单排货位数',
    totalNumber: '总货位数',
    earlyWarning: '货位预警值',
    occupied: '已占货位数',
    remaining: '剩余货位数',
    remark: '备注',
    createdAt: '创建时间',
    createShelfSuccess: '货架创建成功！',
    editShelfSuccess: '货架信息已修改 ',
    existedShelf: '货架编号已存在',
    reviseNumbering: '请修改货架编号'
  },
  commodityLibrary: { // 商品库管理 品类
    pageTitle: '品类管理',
    editTitle: '修改品类',
    viewTitle: '查看品类',
    tableTitle: '品类列表',
    name: '品类名称',
    nameEn: '品类名称',
    id: '鉴定ID',
    brandNum: '品牌数量',
    seriesNum: '系列数量',
    status: '鉴别状态',
    createTitle: '新增品类',
    commQuality: '商品成色',
    packaging: '包装质量',
    categoryImg: '品类图片',
    categoryIcon: '品类图标',
    canVerify: '鉴别状态',
    can: '支持鉴别',
    noVer: '不支持鉴别',
    canAI: 'AI鉴别',
    canOnLine: '在线鉴别',
    categoryImgToolTips: '用于APP鉴定页面的鉴别品类图片展示。建议上传比例为1:1的png格式。',
    categoryIconToolTips: '用于APP鉴定页面的鉴别品类图标展示。建议上传比例1:1的png格式。',
    size: '尺码',
    createCategorySuccess: '品类创建成功！',
    createCategoryFail: '品类创建失败，请稍后重试！',
    editCategorySuccess: '品类修改成功！',
    editCategoryFail: '品类修改失败，请稍后重试！',
    deleteConfirm: '是否要删除该品类？',
    hasUser: '此品类下关联品牌，不可删除！',
    sizeTitle: '尺码',
    editSizeSuccess: '编辑成功！',
    editSizeFail: '编辑失败，请稍后重试！',
    ai: 'AI鉴别（$）:',
    standard: '人工标准鉴别（$）:',
    topspeed: '人工极速鉴别（$）:',
    editPrice: '价格设置'
  },
  brand: { // 品牌
    pageTitle: '品牌管理',
    tableTitle: '品牌列表',
    parentNode: '品类',
    name: '品牌名称',
    nameEn: '品牌名称',
    categoryImg: '品牌图片',
    createTitle: '新增品牌',
    editTitle: '编辑品牌',
    identifyPageTitle: '鉴别点',
    seriesNum: '系列数量',
    isAIIdentification: '支持AI鉴定',
    noIsAIIdentification: '不支持AI鉴定',
    idenInfo: '鉴别信息',
    hasSeries: '该品牌下包含系列，不可删除！',
    hasProduct: '该品牌下包含商品，不可删除！',
    deleteConfirm: '是否要删除该品牌？',
    sizeTitle: '尺码转换',
    point: {
      name: '鉴别点名称',
      nameEn: '鉴别点名称',
      identityImg: '实例图片',
      scopeImg: '拍摄范围',
      describe: '文字描述',
      describeEn: '文字描述',
      createTitle: '新增鉴别点',
      editTitle: '编辑鉴别点',
      createCategorySuccess: '鉴定点创建成功！',
      createCategoryFail: '鉴定点创建失败，请稍后重试！',
      hasPoint: '该鉴定点已存在！',
      editCategorySuccess: '修改鉴定点成功！',
      editCategoryFail: '修改鉴定点失败，请稍后重试！',
      deleteConfirm: '是否删除该鉴定点？'
    },
    detail: {

    },
    hasUser: '此品类下关联品牌，不可删除！',
    isPopular: '是否为热门品牌'
  },
  series: { // 系列
    pageTitle: '系列管理',
    tableTitle: '系列列表',
    parentNode: '品牌',
    name: '系列名称',
    nameEn: '系列名称',
    categoryImg: '系列图片',
    createTitle: '新增系列',
    isAIIdentification: '支持AI鉴定',
    noIsAIIdentification: '不支持AI鉴定',
    editTitle: '编辑系列',
    identifyPageTitle: '鉴别点',
    deleteConfirm: '是否删除该系列？',
    point: {
      name: '鉴别点名称',
      nameEn: '鉴别点名称',
      identityImg: '实例图片',
      scopeImg: '拍摄范围',
      describe: '文字描述',
      describeEn: '文字描述',
      createTitle: '新增鉴别点'
    },
    hasUser: '此品类下关联品牌，不可删除！'
  },
  cargoSpace: { // 货位管理
    pageTitle: '货位管理',
    tableTitle: '货位列表',
    storehouse: '仓库',
    shelves: '货架编号',
    queue: '货排编号',
    slotNumber: '货位编号',
    stock: '库存数量',
    createdAt: '创建时间',
    qrcodeLog: '打印二维码',
    qrcodeLogMul: '批量打印二维码',
    cargoStock: '货位库存',
    print: '打印',
    emptySelected: '请选择需要打印的数据',
    shelf: '货架',
    row: '货排',
    space: '货位',
    serial: '序号',
    taste: '品类',
    brand: '品牌',
    series: '系列',
    name: '名称',
    pid: '商品PID'
  },
  product: { // 商品管理
    pageTitle: '商品管理',
    tableTitle: '商品列表',
    images: '图片',
    name: '名称',
    nameCn: '商品名称（CN）：',
    nameEn: '商品名称（EN）：',
    style: '款号 ',
    taste: '品类',
    brand: '品牌',
    quantity: '库存数量',
    color: '颜色',
    colorCn: '颜色（CN）：',
    colorEn: '颜色（EN）：',
    audience: '适宜人群',
    weight: '重量（磅）',
    createTitle: '新建商品',
    editTitle: '编辑商品',
    viewTitle: '查看商品',
    deleteTitle: '删除商品',
    size: '尺码',
    existedStyle: '款号已存在',
    duplicateBarcode: '存在重复条形码',
    describe: '描述（CN）：',
    describeEn: '描述（EN）：',
    releaseDate: '发售日期',
    unisex: '男女通用',
    men: '男士',
    women: '女士',
    primarySchool: '小学生',
    preschool: '学前班',
    children: '儿童',
    baby: '婴儿'
  },
  aiIdentification: { // AI鉴别
    pageTitle: 'AI鉴别',
    tableTitle: '订单列表',
    orderNo: '订单编号',
    status: '订单状态',
    result: '鉴别结果',
    identifyCategory: '鉴别品类',
    identifyBrand: '鉴别品牌',
    identifySeries: '鉴别系列',
    idenInfo: '鉴别信息',
    remark: '备注',
    theRating: '评级',
    comments: '评论',
    score: '评级'
  },
  identification: { // 在线鉴别
    pageTitle: '在线鉴别',
    tableTitle: '订单列表',
    myIdentification: '我的鉴别',
    orderNo: '订单编号',
    detailedDrawing: '细节图片',
    image: '图片',
    brand: '品牌',
    series: '系列',
    status: '订单状态',
    processing: '处理中',
    complete: '已完成',
    real: '鉴定为真',
    fake: '鉴定为假',
    unable: '无法鉴别',
    authenticationType: '订单类型',
    createdAt: '创建时间',
    accept: '接单',
    acceptTitle: '接单',
    confirmAccept: '确认接受此订单吗？',
    acceptsuccess: '订单接受成功!',
    acceptFailed: '订单接受失败!',
    invalidOrder: '无效的订单',
    orderStatus: '接单状态',
    noOrder: '未接单',
    orderReceived: '已接单',
    appraiser: '鉴定师',
    identify: '鉴定',
    read: '已读',
    scrambling: '抢单中，请稍后',
    identificationDate: '鉴定时间',
    orderList: '订单列表',
    myIdentifications: '我的鉴别'
  },
  /// 提示
  tooltip: {
    imagesSuggest: '建议上传比例为1:1的png格式图片',
    cannotModify: '保存后不支持修改',
    identifyState: '用于APP鉴别品类的显示与隐藏。',
    size: '球鞋尺码请输入美码'
  },
  /// 基础设置
  settings: {
    appSet: 'App配置',
    agreement: '协议内容',
    userAgreementCN: '用户协议（CN）',
    privacyAgreementCN: '隐私协议（CN）',
    aboutUsCN: '关于我们（CN）',
    authenticateCN: '鉴定须知（CN）',
    userAgreementEN: '用户协议（EN）',
    privacyAgreementEN: '隐私协议（EN）',
    authenticateEN: '鉴定须知（EN）',
    aboutUsEN: '关于我们（EN）',
    contactEmail: '联系邮箱',
    setPrice: '鉴定价格'
  },
  // 鉴别结果
  identifyResult: {
    tableTitle: '鉴定结果',
    name: '鉴别点名称',
    identityImg: '实例图片',
    userImg: '客户上传',
    falseArea: '偏假区域',
    describe: '文字描述',
    isReplenish: '是否补图',
    identify: '鉴定信息',
    editSuccess: '修改成功！',
    informUser: '修改成功，已通知用户进行补图！',
    editFail: '修改失败，请稍后重试！',
    result: '鉴定结果',
    isIssue: '是否发布',
    pleaseSelect: '请选择鉴定结果！',
    identifySuccess: '鉴定成功！',
    identifyFail: '鉴定失败，请稍后重试！',
    waitReplenish: '等待用户补图中，暂不支持操作！',
    replenishStatus: '补图状态',
    real: '真',
    fake: '假',
    unable: '无法鉴别'

  },
  // 鉴定价格
  identifyPrice: {
    pageTitle: '鉴定价格',
    tableTitle: '价格设置',
    name: '品类名称',
    nameEn: '品类名称',
    AI: 'AI鉴别',
    standard: '人工标准鉴别',
    topspeed: '人工极速鉴别'
  },
  feedback: { // 意见反馈
    pageTitle: '意见反馈',
    tableTitle: '反馈列表',
    user: '用户名',
    email: '邮箱',
    reply: '回复',
    maxSix: '最多不可超过6张',
    image: '图片',
    describe: '描述文字',
    createdAt: '创建时间',
    logout: '用户已注销',
    replied: '已回复',
    unanswered: '未回复',
    replySuccessfully: '回复成功',
    replyStatus: '回复状态',
    feedbackContent: '回复信息',
    feedbackAt: '回复时间'
  }
}

export default cn
